import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import React, { useEffect, useState } from "react";
import { hasElements } from "utils/arrays";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";
import Link from "components/common_components/Link";
import Status from "components/common_components/Status";

const Forms = ({ forms, category, visible, onClick, onBackClick, selected }) => {
    const [filter, setFilter] = useState("");

    const [filteredForms, setFilteredForms] = useState(forms);

    const onFilterChange = (e) => {
        setFilter(e.target.value);
    };

    useEffect(() => {
        if (selected) {
            setFilteredForms([selected]);
        } else {
            if (filter && hasElements(forms)) {
                setFilteredForms(
                    forms.filter(
                        (form) =>
                            form.code.toLowerCase().includes(filter.toLowerCase()) ||
                            form.issuer.toLowerCase().includes(filter.toLowerCase())
                    )
                );
            } else {
                setFilteredForms(forms);
            }
        }
    }, [filter, forms, selected]);

    return (
        <div
            className={clsx("layout current-forms", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    <Button secondary link onClick={onBackClick}>
                        <Icon name="arrow" color="secondary" size="xs" />
                        <span>Back</span>
                    </Button>
                    <hr />
                    <h3>{category}</h3>
                    {!selected && (
                        <>
                            <small>
                                <i>Select the form</i>
                            </small>
                            <TextField type="text" placeholder="Search..." value={filter} onChange={onFilterChange} />
                        </>
                    )}
                    <div className="forms">
                        {filteredForms.map((form) => (
                            <Card
                                title={
                                    <>
                                        {form.code} {form.isCurrent ? <Status id="active" /> : <Status id="oldVersion" />}
                                    </>
                                }
                                key={form.id}
                                onClick={() => onClick(form)}
                                disabled={selected === form}
                            >
                                <div>
                                    <Link href={form.officialUrl} target="_blank">
                                        <span>{form.issuer}</span>
                                        <Icon name="open-new-tab" color="primary" size="sm" />
                                    </Link>
                                    <div className="form-version">
                                        <span>{`Version ${form.version}`} </span>
                                        <span></span>
                                    </div>
                                    <div className="form-expires">
                                        <span>{`Expires ${form.expiresString}`}</span>
                                    </div>
                                </div>
                                {selected === form && <Icon name="rounded-check" color="extra" size="xlg" />}
                                {selected !== form && (
                                    <Icon name="arrow" color="secondary" size="xs" style={{ transform: "rotate(180deg)" }} />
                                )}
                            </Card>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

Forms.propTypes = {
    forms: PropTypes.array,
    category: PropTypes.string,
    visible: PropTypes.bool,
    onClick: PropTypes.func,
    onBackClick: PropTypes.func,
    selected: PropTypes.object,
};

Forms.defaultProps = {
    forms: [],
    category: null,
    visible: false,
    onClick: () => {},
    onBackClick: () => {},
    selected: null,
};

export default Forms;
